export const GET_AD_PLACEMENT = 'ad-placement';

export const GET_HCP_VERIFICATIONS_QUERY_KEY = 'getHcpVerifications';
